import { render, staticRenderFns } from "./CommonProblemsTwo.vue?vue&type=template&id=42ab9143&scoped=true&"
import script from "./CommonProblemsTwo.vue?vue&type=script&lang=js&"
export * from "./CommonProblemsTwo.vue?vue&type=script&lang=js&"
import style0 from "./CommonProblemsTwo.vue?vue&type=style&index=0&id=42ab9143&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ab9143",
  null
  
)

export default component.exports